// Temporary.jsx
import React from "react";
import PageLayout from '../../Components/PageLayout';

function Temporary() {
    return (
        <PageLayout title="Temporary" subtitle="Temporary overview">
            <div className="container flex col box-container">
                {/* <div className="box">Temporary</div> */}
            </div>
        </PageLayout>   
    );
}

export default Temporary;
